<template>
  <div class="outbox">
    <out-box-message-list :messages="messages"/>
  </div>
</template>

<script>
import ResultType from "../../model/ResultType";
import OutBoxMessageList from './OutBoxMessageList.vue';
export default {
  components: { OutBoxMessageList },
  data() {
    return {
      messages: [],
    };
  },
  mounted() {
    this.GetOutbox();
  },
  methods: {
    GetOutbox() {
      this.$store.dispatch("GetOutbox").then((result) => {
        if (result.type === ResultType.success) {
          this.messages = result.data.Table;
        }
      });
    },
  },
};
</script>

<style>
</style>